import { render, staticRenderFns } from "./device_askCmd_page.vue?vue&type=template&id=01802b5f&scoped=true"
import script from "./device_askCmd_page.vue?vue&type=script&lang=js"
export * from "./device_askCmd_page.vue?vue&type=script&lang=js"
import style0 from "./device_askCmd_page.vue?vue&type=style&index=0&id=01802b5f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01802b5f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01802b5f')) {
      api.createRecord('01802b5f', component.options)
    } else {
      api.reload('01802b5f', component.options)
    }
    module.hot.accept("./device_askCmd_page.vue?vue&type=template&id=01802b5f&scoped=true", function () {
      api.rerender('01802b5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iot/device_askCmd_page.vue"
export default component.exports